export const deleteDocs = {
  DELETE_DOCS_SUCCESS: 'DELETE_DOCS_SUCCESS',
  DELETE_DOCS_ERROR: 'DELETE_DOCS_ERROR',
  DELETE_DOCS_REQUEST: 'DELETE_DOCS_REQUEST',
};
